var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      key: "mobile-menu",
      attrs: { appear: "", name: "menu" },
      on: { enter: _vm.onMenuEnter, "after-enter": _vm.showMenuItems }
    },
    [
      _vm.isMobileOpen
        ? _c(
            "div",
            {
              class: [
                "absolute top-0 left-0 bg-secondary w-full h-screen pt-header-main-mobile"
              ]
            },
            [
              _c("div", { staticClass: "w-full h-full flex flex-col" }, [
                _c(
                  "div",
                  { staticClass: "h-full relative" },
                  [
                    _c(
                      "transition",
                      {
                        key: "menu",
                        attrs: { appear: "", name: "menu" },
                        on: {
                          enter: _vm.onMenuEnter,
                          "after-enter": _vm.showMenuItems
                        }
                      },
                      [
                        _vm.isMobileOpen
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "w-full h-full absolute top-0 left-0 bg-secondary"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden mb-6"
                                  },
                                  [
                                    _c("nav", [
                                      _c(
                                        "ul",
                                        { staticClass: "text-none list-none" },
                                        _vm._l(
                                          _vm.mainMenu.progressiveItems,
                                          function(navItem, index) {
                                            return _c(
                                              "li",
                                              {
                                                key: navItem.id,
                                                class: [
                                                  "flex items-center",
                                                  index === 0 ? "" : "mt-4"
                                                ],
                                                attrs: {
                                                  "data-stagger-item": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    class: [
                                                      "group relative inline-flex items-center h-8",
                                                      navItem.classes
                                                    ],
                                                    attrs: {
                                                      "aria-label":
                                                        "`Open ${navItem.title} menu`"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.activeSubMenuId =
                                                          navItem.id
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "u-body-lg font-bold text-grey-800 focus:outline-none"
                                                      },
                                                      [
                                                        _c("span", {
                                                          class: [
                                                            "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                          ]
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            class: [
                                                              "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                            ]
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  navItem.title
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("Sprite", {
                                                      staticClass:
                                                        "block w-8 h-8 ml-3 text-primary",
                                                      attrs: {
                                                        id: "icon-chevron-right"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("span", {
                                        staticClass:
                                          "block w-[50px] h-[1px] bg-black my-6",
                                        attrs: { "data-stagger-item": "" }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "text-none list-none mb-6"
                                        },
                                        _vm._l(_vm.mainMenu.linkItems, function(
                                          navItem,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: navItem.id,
                                              class: [
                                                "flex items-center",
                                                index === 0 ? "" : "mt-4"
                                              ],
                                              attrs: { "data-stagger-item": "" }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  class: [
                                                    "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                    navItem.classes
                                                  ],
                                                  attrs: {
                                                    href: navItem.url,
                                                    target: navItem.newWindow
                                                      ? "_blank"
                                                      : "_self"
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    class: [
                                                      "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                    ]
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            navItem.title
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "text-none list-none mb-6"
                                        },
                                        _vm._l(_vm.additionalNav, function(
                                          navItem,
                                          index
                                        ) {
                                          return _c(
                                            "li",
                                            {
                                              key: navItem.id,
                                              class: [
                                                "flex items-center",
                                                index === 0 ? "" : "mt-4"
                                              ],
                                              attrs: { "data-stagger-item": "" }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                  attrs: {
                                                    href: navItem.url,
                                                    target: "_self"
                                                  }
                                                },
                                                [
                                                  _c("Sprite", {
                                                    staticClass:
                                                      "block w-6 h-6 mr-3 text-grey-800",
                                                    attrs: { id: navItem.icon }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    class: [
                                                      "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                    ]
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            navItem.title
                                                          ) +
                                                          "\n                      "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.subMenus, function(subMenu) {
                      return _c(
                        "transition",
                        {
                          key: "sub-menu-" + subMenu.id,
                          attrs: { appear: "", name: "sub-menu" },
                          on: {
                            enter: _vm.onMenuEnter,
                            "after-enter": _vm.showMenuItems
                          }
                        },
                        [
                          _vm.isMobileOpen && _vm.activeSubMenuId === subMenu.id
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "w-full h-full absolute top-0 left-0 bg-secondary"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "u-body-sm group relative inline-flex items-center h-8 text-grey-800 font-bold focus:outline-none mb-4"
                                          ],
                                          attrs: {
                                            type: "button",
                                            "aria-label":
                                              "`Close ${subMenu.title} menu`"
                                          },
                                          on: { click: _vm.resetActiveSubMenu }
                                        },
                                        [
                                          _c("span", {
                                            class: [
                                              "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                            ]
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "block w-4 h-8 relative mr-3"
                                            },
                                            [
                                              _c("Sprite", {
                                                staticClass:
                                                  "absolute top-0 left-1/2 -translate-x-1/2 w-8 h-8 text-primary transform rotate-180",
                                                attrs: {
                                                  id: "icon-chevron-right"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(subMenu.title) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "nav",
                                        [
                                          subMenu.children.progressiveItems
                                            .length > 0
                                            ? _c("div", [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "text-none list-none"
                                                  },
                                                  [
                                                    _vm._l(
                                                      subMenu.children
                                                        .progressiveItems,
                                                      function(navItem, index) {
                                                        return _c(
                                                          "li",
                                                          {
                                                            key: navItem.id,
                                                            class: [
                                                              "flex items-center",
                                                              index === 0
                                                                ? ""
                                                                : "mt-4"
                                                            ],
                                                            attrs: {
                                                              "data-stagger-item":
                                                                ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                class: [
                                                                  "group relative inline-flex items-center h-8",
                                                                  navItem.classes
                                                                ],
                                                                attrs: {
                                                                  "aria-label":
                                                                    "`Open ${navItem.title} menu`"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.activeSubSubMenuId =
                                                                      navItem.id
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "u-body-lg font-bold text-grey-800 focus:outline-none"
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      class: [
                                                                        "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                                      ]
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        class: [
                                                                          "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                                        ]
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              navItem.title
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("Sprite", {
                                                                  staticClass:
                                                                    "block w-8 h-8 ml-3 text-primary",
                                                                  attrs: {
                                                                    id:
                                                                      "icon-chevron-right"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    subMenu.url
                                                      ? _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "flex items-center mt-4",
                                                            attrs: {
                                                              "data-stagger-item":
                                                                ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "u-body-lg font-bold text-grey-800 focus:outline-none",
                                                                attrs: {
                                                                  href:
                                                                    subMenu.url
                                                                }
                                                              },
                                                              [
                                                                _c("span", {
                                                                  class: [
                                                                    "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                                  ]
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: [
                                                                      "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                                    ]
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          Explore all\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "block w-[50px] h-[1px] bg-black my-6",
                                                  attrs: {
                                                    "data-stagger-item": ""
                                                  }
                                                })
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          subMenu.children.linkGroups.length > 0
                                            ? _vm._l(
                                                subMenu.children.linkGroups,
                                                function(linkGroup, index) {
                                                  return _c(
                                                    "div",
                                                    { key: linkGroup.id },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "u-body-sm text-grey-800 mb-3",
                                                          attrs: {
                                                            "data-stagger-item":
                                                              ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                linkGroup.title
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "ul",
                                                        {
                                                          staticClass:
                                                            "text-none list-none mb-6"
                                                        },
                                                        _vm._l(
                                                          linkGroup.children,
                                                          function(
                                                            navItem,
                                                            itemIndex
                                                          ) {
                                                            return _c(
                                                              "li",
                                                              {
                                                                key: navItem.id,
                                                                class: [
                                                                  "flex items-center",
                                                                  itemIndex ===
                                                                  0
                                                                    ? ""
                                                                    : "mt-2"
                                                                ],
                                                                attrs: {
                                                                  "data-stagger-item":
                                                                    ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                                    attrs: {
                                                                      href:
                                                                        navItem.url,
                                                                      target:
                                                                        "_self"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c("span", {
                                                                      class: [
                                                                        "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                                      ]
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        class: [
                                                                          "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                                        ]
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              navItem.title
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _vm._v(" "),
                                                      index !==
                                                      subMenu.children
                                                        .linkGroups.length -
                                                        1
                                                        ? _c("span", {
                                                            staticClass:
                                                              "block w-[50px] h-[1px] bg-black my-6",
                                                            attrs: {
                                                              "data-stagger-item":
                                                                ""
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  )
                                                }
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          subMenu.children.linkItems.length > 0
                                            ? _c("div", [
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "text-none list-none mb-6"
                                                  },
                                                  _vm._l(
                                                    subMenu.children.linkItems,
                                                    function(navItem, index) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key: navItem.id,
                                                          class: [
                                                            "flex items-center",
                                                            index === 0
                                                              ? ""
                                                              : "mt-4"
                                                          ],
                                                          attrs: {
                                                            "data-stagger-item":
                                                              ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              class: [
                                                                "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                                navItem.classes
                                                              ],
                                                              attrs: {
                                                                href:
                                                                  navItem.url,
                                                                target: navItem.newWindow
                                                                  ? "_blank"
                                                                  : "_self"
                                                              }
                                                            },
                                                            [
                                                              _c("span", {
                                                                class: [
                                                                  "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                                ]
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  class: [
                                                                    "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                                  ]
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        navItem.title
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      subMenu.attributes &&
                                      subMenu.attributes.communityPostcodeSearch
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "p-5 bg-white rounded-lg",
                                              attrs: { "data-stagger-item": "" }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "u-body-md text-grey-800 text-center mb-3"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Find the perfect community\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("NearbyInput", {
                                                attrs: {
                                                  type: "communities",
                                                  placeholder:
                                                    "Enter your postcode",
                                                  communities: _vm.communities,
                                                  nearbyRedirectUrl:
                                                    _vm.findCommunitiesUrl
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      subMenu.attributes &&
                                      subMenu.attributes.homesPostcodeSearch
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "p-5 bg-white rounded-lg",
                                              attrs: { "data-stagger-item": "" }
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "u-body-md text-grey-800 text-center mb-3"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Find the perfect home\n                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("NearbyInput", {
                                                attrs: {
                                                  type: "homesForSale",
                                                  placeholder:
                                                    "Enter your postcode",
                                                  communities: _vm.communities,
                                                  nearbyRedirectUrl:
                                                    _vm.findHomesUrl
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.subSubMenus, function(subSubMenu) {
                      return _c(
                        "transition",
                        {
                          key: "sub-sub-menu-" + subSubMenu.id,
                          attrs: { appear: "", name: "sub-menu" },
                          on: {
                            enter: _vm.onMenuEnter,
                            "after-enter": _vm.showMenuItems
                          }
                        },
                        [
                          _vm.isMobileOpen &&
                          _vm.activeSubSubMenuId === subSubMenu.id
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "w-full h-full absolute top-0 left-0 bg-secondary"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden"
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            "u-body-sm group relative inline-flex items-center h-8 text-grey-800 font-bold focus:outline-none mb-4"
                                          ],
                                          attrs: {
                                            type: "button",
                                            "aria-label":
                                              "`Close ${subSubMenu.title} menu`"
                                          },
                                          on: {
                                            click: _vm.resetActiveSubSubMenu
                                          }
                                        },
                                        [
                                          _c("span", {
                                            class: [
                                              "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                            ]
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "block w-4 h-8 relative mr-3"
                                            },
                                            [
                                              _c("Sprite", {
                                                staticClass:
                                                  "absolute top-0 left-1/2 -translate-x-1/2 w-8 h-8 text-primary transform rotate-180",
                                                attrs: {
                                                  id: "icon-chevron-right"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              class: [
                                                "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(subSubMenu.title) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("nav", [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "text-none list-none mb-6"
                                          },
                                          [
                                            _vm._l(
                                              subSubMenu.children,
                                              function(navItem, index) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: navItem.id,
                                                    class: [
                                                      "flex items-center",
                                                      index === 0 ? "" : "mt-4"
                                                    ],
                                                    attrs: {
                                                      "data-stagger-item": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        class: [
                                                          "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                          navItem.classes
                                                        ],
                                                        attrs: {
                                                          href: navItem.url,
                                                          target: navItem.newWindow
                                                            ? "_blank"
                                                            : "_self"
                                                        }
                                                      },
                                                      [
                                                        _c("span", {
                                                          class: [
                                                            "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                          ]
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            class: [
                                                              "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                            ]
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  navItem.title
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        navItem.tag !== null
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "u-body-sm font-bold bg-white border-1 border-solid border-grey-700 py-1 px-2 rounded-md ml-2"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    navItem.tag
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            subSubMenu.url
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "flex items-center mt-4",
                                                    attrs: {
                                                      "data-stagger-item": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        class: [
                                                          "u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none",
                                                          subSubMenu.classes
                                                        ],
                                                        attrs: {
                                                          href: subSubMenu.url,
                                                          target: subSubMenu.newWindow
                                                            ? "_blank"
                                                            : "_self"
                                                        }
                                                      },
                                                      [
                                                        _c("span", {
                                                          class: [
                                                            "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                                                          ]
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            class: [
                                                              "group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out"
                                                            ]
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        Explore all\n                      "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "px-5 py-8" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex justify-center gap-x-3",
                      attrs: { "data-stagger-item": "" }
                    },
                    [
                      _c("CtaButton", {
                        attrs: {
                          buttonType: "primary",
                          label: _vm.enquireCtaLabel,
                          url: _vm.enquireCtaUrl
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }